import { render, staticRenderFns } from "./EditSpeaker.vue?vue&type=template&id=524928b3&"
import script from "./EditSpeaker.vue?vue&type=script&lang=js&"
export * from "./EditSpeaker.vue?vue&type=script&lang=js&"
import style0 from "./EditSpeaker.vue?vue&type=style&index=0&id=524928b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports